<template>
  <section>
    <h1>报名列表</h1>
<!--    <el-button @click="addFormVisible=true">新增比赛</el-button>-->


    <el-table :data="orderList" highlight-current-row v-loading="false"style="width: 100%;">
<!--      <el-table-column prop="id" label="id" sortable>-->
<!--      </el-table-column>-->
      <el-table-column prop="username" label="手机号">
      </el-table-column>
      <el-table-column prop="name" label="名字" >
      </el-table-column>
      <el-table-column prop="idNumber" label="身份证号" >
      </el-table-column>
      <el-table-column prop="conname" label="分组" >
      </el-table-column>
      <el-table-column align="center" label="报名时间" >
        <template scope="scope">
          {{ dateFormat( "yyyy-MM-dd hh:mm:ss", new Date(scope.row.create_at))}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" >
        <template scope="scope">
          <span v-if="scope.row.status ==1" style="color: red"> 已提交</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="证件照片" >
        <template scope="scope">
          <a target="_blank" :href="baseUrl+scope.row.photo"> 点击查看 </a>
        </template>
      </el-table-column>
      <el-table-column align="center" label="证书" >
        <template scope="scope">
          <span v-if="scope.row.certsta ==1" style="color: #a86348"> 证书待确认</span>
          <span v-else-if="scope.row.certsta ==2" style="color: red"> 证书异常</span>
          <span v-else-if="scope.row.certsta ==3" style="color: #27932e"> 证书已确认</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="证书操作" >
        <template scope="scope">
          <el-button type="danger" @click="change(scope.$index,'certsta','2')">证书标异常</el-button>
          <el-button type="success" @click="change(scope.$index,'certsta','3')">证书标确认</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="付款" >
        <template scope="scope">
          <span v-if="scope.row.paysta ==1" style="color: #a86348"> 付款待确认</span>
          <span v-else-if="scope.row.paysta ==2" style="color: red"> 付款异常</span>
          <span v-else-if="scope.row.paysta ==3" style="color: #27932e"> 付款已确认</span>
        </template>

      </el-table-column>
      <el-table-column align="center" label="付款操作" >
        <template scope="scope">
          <el-button type="danger" @click="change(scope.$index,'paysta','2')">付款标异常</el-button>
          <el-button type="success" @click="change(scope.$index,'paysta','3')">付款标确认</el-button>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" >
        <template scope="scope">
          <el-button type="danger" @click="calcel(scope.$index)">取消报名</el-button>
<!--          <el-button type="success" @click="succuss(scope.row.username)">确认已付费有参赛资格</el-button>-->
        </template>
      </el-table-column>
    </el-table>
  </section>
</template>

<script>

import {baseUrl} from '../../config.js'
export default {
  name: 'order2',
  data() {
    return {
      addFormVisible:false,
      orderList:[],
      addForm:{},
      baseUrl,
    }
  },
  methods:{
    dateFormat (format,date) {
      var o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S": date.getMilliseconds()
      }
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    calcel(index){
      console.log(index)
      let username = this.orderList[index].username
      let name = this.orderList[index].name
      this.$http.postData('cancel2',{name:name,username:username,remark:"后台管理员取消"},(data)=>{
        this.$message.success("删除成功");
        this.orderList.splice(index,1)

      },(data)=>{
        this.$message.error(data.message);
      })
    },
    change(index,type,status){
      console.log(index)
      let username = this.orderList[index].username
      let name = this.orderList[index].name
      this.$http.postData('status2',{name:name,username:username,type:type,status:status },(data)=>{
        this.$message.success("修改成功");
        this.orderList[index][type]=status
      },(data)=>{
        this.$message.error(data.message);
      })
    },
    getData(){
      this.$http.getData('order2',(data)=>{
        this.orderList=data.result;
      },(data)=>{
        this.$message.error(data.message);
      })
    },
    addSubmit(){
      this.$http.postData('contest',this.addForm,(data)=>{
        this.$message.success(data.message);
        this.addFormVisible=false;
        this.addForm={};
        this.getData();
      },(data)=>{
        this.$message.error(data.message);
      })
    }
  },
  mounted(){
    this.getData()
  },
}
</script>

<style scoped>
</style>
